import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined"
import { useState } from "react"
import { Position } from "reactflow"

import CustomHandle from "../../CustomHandle"
import { getEditorData } from "../../utils"
import BaseNode, { GreenNodeLabel, NodeContentLayout } from "../BaseNode"
import TaskNodeEditor from "./Editor"

export default function TaskNode(node) {
  const [editorOpen, setEditorOpen] = useState(false)
  const taskConfig = getEditorData(node)

  function handleBaseNodeClicked(e) {
    setEditorOpen(true)
  }

  return (
    <>
      <BaseNode node={node} rootProps={{ onClick: handleBaseNodeClicked }}>
        <CustomHandle
          id="top-handle"
          type="target"
          position={Position.Top}
          node={node}
        />
        <GreenNodeLabel label="Action" />
        <NodeContentLayout
          title="Task"
          subtitle={
            taskConfig?.title ? taskConfig.title : "Task not configured"
          }
          Icon={AssignmentOutlinedIcon}
        />
        <CustomHandle
          id="bottom-handle"
          type="source"
          position={Position.Bottom}
          node={node}
        />
      </BaseNode>
      <TaskNodeEditor
        open={editorOpen}
        onClose={() => setEditorOpen(false)}
        node={node}
      />
    </>
  )
}
